export const faqItems = [
  {
    question: "BaoyuTV是什么？",
    answer: "BaoyuTV是一款备受用户青睐的高清视频平台，提供海量影视、综艺、动漫等内容资源。平台采用先进的视频编码技术和全球CDN加速网络，为用户带来流畅、高清的观影体验。支持手机、平板、电脑、智能电视等多终端访问。",
  },
  {
    question: "BaoyuTV如何保证高清画质？",
    answer: "BaoyuTV采用H.265/HEVC高效视频编码标准，支持最高4K分辨率播放，搭配HDR技术呈现细腻逼真的画面。同时搭载智能码率自适应技术，根据您的网络状况自动调节最佳画质，确保流畅不卡顿。",
  },
  {
    question: "BaoyuTV是否需要付费？",
    answer: "BaoyuTV提供免费和会员两种模式。免费用户可以观看海量内容（含少量广告），会员用户可享受4K超清画质、无广告观影、离线下载、多端同步等专属权益。会员分为月卡、季卡、年卡三种套餐。",
  },
  {
    question: "如何找到BaoyuTV最新官方入口？",
    answer: "建议通过浏览器收藏BaoyuTV官方主域名，或关注BaoyuTV官方社交媒体账号获取最新入口信息。请注意识别仿冒网站，官方不会通过弹窗广告等方式引导访问。",
  },
  {
    question: "BaoyuTV支持哪些设备？",
    answer: "BaoyuTV全面支持iOS、Android手机和平板、Windows/Mac电脑、Android TV/Apple TV智能电视等主流设备。用户可在官网或应用商店下载对应客户端，登录同一账号即可同步观看记录。",
  },
  {
    question: "BaoyuTV的会员可以退款吗？",
    answer: "BaoyuTV会员支持购买后7天内无理由退款（需未大量使用会员权益）。退款申请可在App内'我的-会员中心-退款申请'中提交，审核通过后款项将原路返回。",
  },
  {
    question: "BaoyuTV的内容更新频率如何？",
    answer: "BaoyuTV每日更新海量内容：热门剧集同步卫视更新，电影大片及时上线，动漫番剧每周同步日本播出。平台拥有专业的内容采编团队，确保用户第一时间看到最新内容。",
  },
  {
    question: "BaoyuTV的离线下载功能如何使用？",
    answer: "会员用户可在视频详情页点击下载按钮，选择画质后即可离线缓存。下载内容在'我的-下载管理'中查看和管理。注意下载内容有30天有效期，过期后需重新下载。",
  },
];

export const homepageSchema = {
  title: "BaoyuTV官方入口·高清视频平台 - 海量影视综艺动漫资源",
  description: "baoyutv是备受用户青睐的高清视频平台，提供海量影视、综艺、动漫等内容资源。本页为您详解baoyutv的核心功能、使用方法、最新入口及常见问题，助您快速畅享优质视频体验。",
  keywords: "baoyutv,baoyutv官网入口,baoyutv最新地址,baoyutv高清视频,baoyutv使用教程,baoyutv资源下载,baoyutv会员权益",
};